export default {
  releasedOrders: [],
  cancellingOrders: [],
  hasPendingPurchases: false
}
